export interface FeatureConfig {
  projects: boolean;
  dashboard: boolean;
  tasks: boolean;
  workOrders: boolean;
  team: boolean;
  schedule: boolean;
  documents: boolean;
  companies: boolean;
  leads: boolean;
  profile: boolean;
  locations: boolean;
  budgets: boolean;
  inventory: boolean;
  accounting: boolean;
  notifications: boolean;
  partners: boolean;
  welcomeTour: boolean;
}

export const featureConfig: FeatureConfig = {
  projects: process.env.REACT_APP_FEATURE_PROJECTS === 'true',
  dashboard: process.env.REACT_APP_FEATURE_DASHBOARD === 'true',
  tasks: process.env.REACT_APP_FEATURE_TASKS === 'true',
  workOrders: process.env.REACT_APP_FEATURE_WORK_ORDERS === 'true',
  team: process.env.REACT_APP_FEATURE_TEAM === 'true',
  schedule: process.env.REACT_APP_FEATURE_SCHEDULE === 'true',
  documents: process.env.REACT_APP_FEATURE_DOCUMENTS === 'true',
  companies: process.env.REACT_APP_SUPERADMIN_PANEL === 'true',
  leads: process.env.REACT_APP_FEATURE_LEADS === 'true',
  profile: process.env.REACT_APP_FEATURE_PROFILE === 'true',
  locations: process.env.REACT_APP_FEATURE_LOCATIONS === 'true',
  budgets: process.env.REACT_APP_FEATURE_BUDGETS === 'true',
  inventory: process.env.REACT_APP_FEATURE_INVENTORY === 'true',
  accounting: process.env.REACT_APP_FEATURE_ACCOUNTING === 'true',
  notifications: true,
  partners: process.env.REACT_APP_FEATURE_PARTNERS === 'true',
  welcomeTour: process.env.REACT_APP_FEATURE_WELCOME_TOUR === 'true',
};
